import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "title"
};
var _hoisted_2 = {
  class: "notice-update-body"
};
var _hoisted_3 = ["srcdoc"];
import { computed } from 'vue';
export default {
  __name: 'NoticeUpdateDialog',
  props: /*@__PURE__*/_mergeModels({
    data: {
      type: Object,
      default: function _default() {}
    }
  }, {
    "visible": false,
    "visibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['change'], ["update:visible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var visible = _useModel(__props, 'visible', false);
    var props = __props;
    var emit = __emit;
    var iframeDoc = computed(function () {
      var _props$data;
      return "\n    <!DOCTYPE html>\n    <html lang=\"en\">\n    <head>\n      <meta charset=\"UTF-8\">\n      <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n      </head>\n      <style>\n        body {\n          font-family: 'Microsoft YaHei';\n          font-size: 14px;\n        }\n        ::-webkit-scrollbar {\n          display: none;\n        }\n        ::-webkit-scrollbar-track {\n          background: #ffffff;\n        }\n        ::-webkit-scrollbar-thumb {\n          background: #ffffff;\n        }\n        ::-webkit-scrollbar-thumb:hover {\n          background: #ffffff;\n        }\n      </style>\n    <body>\n      ".concat(((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.content) || '', "\n    </body>\n    </html>\n  ");
    });

    /**
     * 取消
     */
    var handleCancel = function handleCancel() {
      visible.value = false;
      emit('change');
    };
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        width: "558px",
        class: "notice-update-dialog",
        "close-on-overlay-click": false,
        "close-btn": false
      }, {
        header: _withCtx(function () {
          var _props$data2;
          return [_createElementVNode("h3", _hoisted_1, _toDisplayString(((_props$data2 = __props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.title) || ''), 1)];
        }),
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("iframe", {
            class: "custom-scrollbar",
            srcdoc: iframeDoc.value,
            frameborder: "0"
          }, null, 8, _hoisted_3)])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_t_button, {
            theme: "primary",
            size: "large",
            onClick: handleCancel
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode(" 知道了 ", -1)]));
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};